export const NEGATIVE_CATEGORY_LABELS = {
  complaint: 'Жалоба',
  alert: 'Критичное обращение',
  negative: 'Жалоба',
  no_response_or_followup: 'Нет ответа или продолжения',
  room_or_facility_problem: 'Проблема в номере / корпусе',
  medical_or_procedure_service: 'Медицинский / процедурный сервис',
  booking_or_availability: 'Бронь, места или расписание',
  price_or_documents: 'Цена или документы',
  staff_communication: 'Коммуникация сотрудников',
  poor_procedure_quality: 'Недовольство результатом процедуры',
  refund_request: 'Запрос возврата',
  negative_review_threat: 'Угроза негативного отзыва',
  authority_complaint_threat: 'Угроза обращения в инстанции',
  service_or_communication: 'Сервис или коммуникация',
  service_quality: 'Сервис или коммуникация',
  none: 'Нет жалобы',
  other: 'Другая жалоба'
};

export const NEGATIVE_SUB_CATEGORY_LABELS = {
  safety_issue: 'Риск безопасности/поломки',
  repeated_unresolved: 'Повторно не решено',
  no_clear_next_step: 'Нет ясного следующего шага',
  low_quality_call: 'Низкое качество звонка',
  no_response_or_followup: 'Нет ответа или продолжения',
  room_or_facility_problem: 'Проблема в номере / корпусе',
  medical_or_procedure_service: 'Медицинский / процедурный сервис',
  booking_or_availability: 'Бронь, места или расписание',
  price_or_documents: 'Цена или документы',
  staff_communication: 'Коммуникация сотрудников',
  poor_procedure_quality: 'Недовольство результатом процедуры',
  refund_request: 'Запрос возврата',
  negative_review_threat: 'Угроза негативного отзыва',
  authority_complaint_threat: 'Угроза обращения в инстанции',
  service_or_communication: 'Сервис или коммуникация',
  service_quality: 'Сервис или коммуникация',
  none: 'Нет жалобы',
  other: 'Другая жалоба'
};

const humanizeCode = (value) =>
  String(value ?? '')
    .trim()
    .split('_')
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase() + part.slice(1))
    .join(' ');

export const formatNegativeCategory = (value) => {
  if (!value) return '—';
  const key = String(value).trim().toLowerCase();
  return NEGATIVE_CATEGORY_LABELS[key] ?? humanizeCode(key) ?? String(value);
};

export const formatNegativeSubCategory = (value) => {
  if (!value) return '—';
  const key = String(value).trim().toLowerCase();
  return NEGATIVE_SUB_CATEGORY_LABELS[key] ?? humanizeCode(key) ?? String(value);
};
